<p translate="payment-panel-pay-with-code_access-course-with-access-code"></p>
<mat-form-field appearance="outline">
  <mat-label translate="payment-panel-pay-with-code_access-code"></mat-label>
  <input matInput
    [placeholder]="'payment-panel-pay-with-code_access-code-label' | translate: { sampleCode: 'XAH3JOZS9RKC' }"
    [formControl]="code"
    class="fullstory-ignore"
    />
  @if (code.hasError('required')) {
    <mat-error>{{'common_required_field' | translate}}</mat-error>
  }
</mat-form-field>
